import { CommonModule } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router, RouterOutlet } from "@angular/router";
import { OrganizationPublicAccessKeyDto } from "../../../../../assist/src/app/organisation/models/organization";
import { UserPersonListDto } from "../../user/models/user-person";
import { FooterComponent } from "../footer/footer.component";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { PersonModalComponent } from "../../user/pages/person-modal/person-modal.component";
import { OrganizationService } from "../../organization/services/oranization.service";
import { UserPersonService } from "../../user/services/user-person.service";

@Component({
  selector: "app-public-layout",
  styleUrl: "./public-layout.component.scss",
  templateUrl: "./public-layout.component.html",
  standalone: true,
  imports: [CommonModule, RouterOutlet, FooterComponent],
})
export class PublicLayoutComponent implements OnInit {
  title = "Assist";
  persons: UserPersonListDto[] = [];
  organization: OrganizationPublicAccessKeyDto = {} as OrganizationPublicAccessKeyDto;

  constructor(
    protected route: ActivatedRoute,
    protected router: Router,
    //public auth: AssistAuthService,
    protected userPersonService: UserPersonService,
    protected organizationService: OrganizationService,
    private modalService: NgbModal
  ) { }

  ngOnInit(): void {
    if (this.router.url.indexOf("waitinglist/add") == -1) {
      document.documentElement.style.setProperty("--banner-color-1", "#0061f2");
      document.documentElement.style.setProperty("--banner-color-2", "rgba(105,0,199,.8)");
    }

    if (this.router.url === '/' || this.router.url.startsWith('/?')) {
      var modal = this.modalService.open(PersonModalComponent, {
        backdrop: 'static',
        keyboard: false
      });

      this.organizationService.getAccessKey().subscribe((o) => {
        this.organization = o;
        this.userPersonService.getAll('?organizationKey=' + this.organization.accessKey).subscribe(x => {
          this.persons = x;
          if (this.persons.length == 1) {
            const person = this.persons[0];
            this.router.navigate(['/NL/', this.organization.accessKey, 'person', person.person.accessKey, 'edit']);
          }
        })
      });
    }

  }
}
